import React, { useEffect } from "react";
import { useNodeContext } from "../../../../context/NodeContext";
import { useFormContext } from "../../../../context/FormContext";
import { useState } from "react";
import { Handle, Position } from "@xyflow/react";
import { MdDeleteOutline, MdMarkEmailRead } from "react-icons/md";

const EmailVerifyNode = ({ id, data, isConnectable }) => {
  const {
    nodes,
    setShowShapeUpdateForm,
    shapeId,
    setShapeId,
    handleNodeDelete,
  } = useNodeContext();
  const { setNewFormId, fetchForms } = useFormContext();
  const [isDelBtn, setDelBtn] = useState(false);

  // useEffect for shoeing del button not active
  useEffect(() => {
    if (id === shapeId) {
      setDelBtn(true);
    } else {
      setDelBtn(false);
    }
  }, [shapeId]);

  const handleClick = (e) => {
    e.stopPropagation();
    setDelBtn(!isDelBtn);
    if (Array.isArray(nodes)) {
      const selectedNode = nodes.find((node) => node.id === id);
      if (selectedNode.data.form === "" || selectedNode.data.form === null) {
        setNewFormId(null);
        fetchForms();
      } else {
        setNewFormId(selectedNode.data.form.form_builder_id);
      }
    }
    setShowShapeUpdateForm(true);
    setShapeId(id);
  };
  return (
    <div className="" onClick={handleClick}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ top: "50%", left: "1px", zIndex: "1" }}
        isConnectable={isConnectable}
        // connectionCount={1}
      />
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "0px",
        }}
      >
        <MdMarkEmailRead style={{ fontSize: "30px" }} />
        <span
          style={{
            position: "absolute",
            fontSize: "8px",
            bottom: "-7px",
            width: "max-content",
          }}
        >
          {data.value}
        </span>
        {isDelBtn && (
          <button
            style={{ top: "-5px", right: "-10px" }}
            className="btn pm_shape_del_btn"
            onClick={handleNodeDelete}
          >
            <MdDeleteOutline />
          </button>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        style={{ top: "50%", right: "2px" }}
        isConnectable={isConnectable}
      />
    </div>
  );
};

export default EmailVerifyNode;
